import React, { useEffect, useState, useContext } from "react";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, TextField, IconButton, InputAdornment, Tooltip } from '@mui/material';
import Modal from 'react-bootstrap/Modal';
import { Row, Col } from "react-bootstrap";
import { styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import ApiService from '../../functions/apiService';
import moment from "moment";
import SearchIcon from "@mui/icons-material/Search";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { varFormatTime } from "../../utils/helperFunctions";
import AuthContext from "../../context/AuthContext";
import { toast } from 'react-toastify';

const Hitlist = (props) => {
	const { date, open, setOpen, selectedName, setSelectedName, isNight, loadData } = props
	const { user, pages, v3Data } = useContext(AuthContext);
	const [modalContent, setModalContent] = useState('default');
	const [position, setPosition] = useState('');
	const [empList, setEmpList] = useState([])
	const [search, setSearch] = useState('')
	const [empCode, setEmpCode] = useState('')
	const [positionArr, setPositionArr] = useState([])
	const [selectedNameEmp, setSelectedNameEmp] = useState('');
	const [clearModal, setClearModal] = useState(false);

	const handleClose = () => {
		setOpen(false);
		setSelectedName('');
		setModalContent('default');
	}

	const handleChangeContent = (row) => {
		setModalContent('selected');
		setEmpCode(row?.Emp_Code)
		setSelectedNameEmp(row.employee.employee_assignment.EA_Rank + " " + row.employee.fullName);
	}

	const handleContentDefault = () => {
		setModalContent('default');
		setSelectedNameEmp('');
		setPosition('');
	}

	const handleChange = (event) => {
		setPosition(event.target.value);
	};

	let getHitlistEmp = () => {
		if (search == '' || search.length > 2) {
			let code = isNight ? 3 : 2
			ApiService.get(`/getHitlistEmployees?date=${moment(date).format('YYYY-MM-DD')}&shiftCode=${code}&search=${search}`)
				.then((data) => {
					setEmpList(data.data.data)
				})
				.catch(() => {
				})
		}
	}

	let getPositionDropdown = () => {
		if (empCode) {
			let code = isNight ? 3 : 2
			ApiService.get(`/getHitlistEmployeesPositions/${empCode}?date=${moment(date).format('YYYY-MM-DD')}&shiftCode=${code}`)
				.then((data) => {
					setPositionArr(data.data.data)
				})
				.catch(() => {
				})
		}
	}

	let onSubmitAssign = (refresh = false) => {
		const req = {
			"Shift_Number": position.Shift_Number,
			"Shift_Date": moment(date).format('YYYY-MM-DD'),
			"Emp_Code": empCode,
			...(refresh && { "clear_hitlist": true }),
		}
		ApiService.post('/hitlistAssignEmp', req)
			.then((res) => {
				loadData(moment(date).format('DD-MM-YYYY'))
				toast.success(res?.message)
				setOpen(false)
			}).catch((err) => {
				toast.error(err?.data?.message)
			})
	}

	const clearHitlist = () => {
		const req = {
			"Shift_Date": moment(date).format('YYYY-MM-DD'),
			"Shift_Code": isNight ? 3 : 2,
		}
		ApiService.post('/admin-revert-all-overtime-signup', req)
			.then((res) => {
				toast.success(res?.message)
				setClearModal(false)
				getHitlistEmp()
				loadData(moment(date).format('DD-MM-YYYY'))
				setOpen(false)
			}).catch((err) => {
				toast.error(err?.data?.message)
				setClearModal(false)
			})
	}

	useEffect(() => {
		getHitlistEmp()
	}, [isNight, search])

	useEffect(() => {
		getPositionDropdown()
	}, [empCode])

	// Same resolution order as the "Blast Fill Sent" column
	const getBlastFillTime = (row) => {
		if (row?.shift_call_request?.Update_Time) {
			return moment(row.shift_call_request.Update_Time)
		}
		if (row?.shift_call_request?.Call_Date_Times) {
			return moment(row.shift_call_request.Call_Date_Times.split(',').pop().trim())
		}
		return null
	}

	// Blue when no blast fill was sent to this employee, or when the overtime signup landed an
	// hour or more after it; red while the signup is still inside that hour. Only ever shown
	// when V3_KEEP_HITLIST_ASSIGN_BUTTON_ACTIVE is on.
	const getSignupDelay = (row) => {
		if (v3Data?.V3_KEEP_HITLIST_ASSIGN_BUTTON_ACTIVE !== 'true') return null
		const blastFill = getBlastFillTime(row)
		if (!blastFill?.isValid()) {
			return { color: 'blue', message: 'Sign up done after blast fill entries cleared' }
		}
		const signup = row?.Change_Time ? moment(row.Change_Time) : null
		if (!signup?.isValid()) return null
		if (signup.diff(blastFill, 'minutes') >= 60) {
			return { color: 'blue', message: 'Overtime sign up done 1 hour after blast fill' }
		}
		return null
	}

	return (
		<>
			<Modal size={v3Data?.V3_SHOW_OT_SIGNUP_TIMESTAMP ? "xl" : "lg"} show={open} onHide={handleClose}>
				<Modal.Body className='p-4'>
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
						{modalContent === 'default' ?
							<Typography id="modal-modal-title" sx={{ fontSize: '21px', fontWeight: '700' }}>
								{selectedName} (Available personnel)
							</Typography>
							:
							<Typography id="modal-modal-title" sx={{ fontSize: '18px', cursor: 'pointer' }} onClick={handleContentDefault}>
								Back
							</Typography>
						}
						<div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
							{modalContent === 'default' && empList.length > 0 && (
								<ButtonTheme color='primary' onClick={() => setClearModal(true)}>
									Clear List
								</ButtonTheme>
							)}
							<img src="/images/close-icon.svg" style={{ cursor: 'pointer' }} onClick={handleClose} />
						</div>
					</div>
					{modalContent === 'default' ?
						<Box id="modal-modal-description" sx={{ mt: 2 }}>
							<TextField
								variant="outlined"
								placeholder="Search by Name"
								className="mt-0 w-100"
								color='secondary'
								onChange={(e) => setSearch(e.target.value)}
								InputProps={{
									endAdornment: (
										<InputAdornment position="end">
											<IconButton>
												<SearchIcon />
											</IconButton>
										</InputAdornment>
									),
									sx: {
										height: '48px',
										fontSize: '14px'
									},
								}}
							/>
							<div style={{ maxHeight: '60vh', overflow: 'scroll', scrollbarWidth: 'none' }}>
								<TableContainer component={Paper} sx={{
									boxShadow: 'none !important',
									border: '1px solid #EAECF0',
									mt: 2
								}}>
									<Table aria-label="customized table">
										<TableHead sx={{ backgroundColor: "#E5E9EB" }} >
											<TableRow>
												<TableCell>Name</TableCell>
												{v3Data?.V3_SHOW_OT_SIGNUP_TIMESTAMP && (
													<TableCell>Signup Date</TableCell>
												)}
												<TableCell>Available Schedule</TableCell>
												<TableCell>Seniority</TableCell>
												<TableCell>Hours</TableCell>
												{v3Data?.V3_SHOW_OT_SIGNUP_TIMESTAMP && (
													<TableCell>Blast Fill Sent</TableCell>
												)}
												<TableCell>Action</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{empList.length > 0 ? empList.map((row) => (
												<TableRow key={row.employee.fullName} sx={{
													height: '22px',
													'& .MuiTableCell-root': {
														border: 'none'
													},
													'&:nth-of-type(even)': {
														backgroundColor: 'rgba(204, 204, 204, 0.2)',
													},
												}}>
													<TableCell component="th" scope="row">
														<Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
															{`${row.employee.employee_assignment.EA_Rank} ${row.employee.fullName}`}
															{row?.Emp_Working_Custom &&
																<Tooltip title="Employee working as custom or detail" arrow>
																	<InfoOutlinedIcon sx={{ fontSize: '18px', color: '#BF1D2D' }} />
																</Tooltip>
															}
														</Box>
													</TableCell>
													{v3Data?.V3_SHOW_OT_SIGNUP_TIMESTAMP && (
														<TableCell component="th" scope="row">
															{row?.Change_Time ? moment(row.Change_Time).format('MM/DD/YYYY HH:mm') : '-'}
														</TableCell>
													)}
													<TableCell component="th" scope="row">
														{moment(row.Shift_Date).format('dddd')} {row?.Value != 'FULLTIME' ? 'on ' + row.Value.replace(/(^\s*,)|(,\s*$)/g, '') : ''}
													</TableCell>
													<TableCell component="th" scope="row">
														{row.employee.EHd_Seniority}
													</TableCell>
													<TableCell component="th" scope="row">
														{row?.Hours_New ?
															<div>
																<p style={{ marginTop: '0px', marginBottom: '0px' }}>Hours : {row?.Hours}</p>
																<p style={{ marginTop: '0px', marginBottom: '0px' }}>New Hours : {row?.Hours_New}</p>
															</div>
															:
															<p style={{ marginTop: '0px', marginBottom: '0px' }}>{row.Hours || '0'}</p>
														}
													</TableCell>
													{v3Data?.V3_SHOW_OT_SIGNUP_TIMESTAMP && <TableCell component="th" scope="row">
														{
															row?.shift_call_request?.Update_Time
																? moment(row.shift_call_request.Update_Time).format('MM/DD/YYYY HH:mm')
																: row?.shift_call_request?.Call_Date_Times
																	? moment(
																		row.shift_call_request.Call_Date_Times
																			.split(',')
																			.pop()
																			.trim()
																	).format('MM/DD/YYYY HH:mm')
																	: '-'
														}
													</TableCell>}
													<TableCell component="th" scope="row" align="right">
														<Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
															{(!pages.includes('V3_NEW_FILL_STRUCTURE')) || (pages.includes('V3_NEW_FILL_STRUCTURE') && (v3Data?.V3_KEEP_HITLIST_ASSIGN_BUTTON_ACTIVE === 'true' || row?.Shift_Call_Status == 'accepted')) ?
																<Chip sx={{
																	height: 'auto',
																	color: 'red',
																	'& .MuiChip-label': {
																		display: 'block',
																		whiteSpace: 'normal',
																	},
																}}
																	style={{ textAlign: 'center', padding: '6px 0px', width: '100%', cursor: 'pointer' }}
																	label='Assign Shift'
																	color={getSignupDelay(row)?.color || 'red'}
																	onClick={() => handleChangeContent(row)}
																/>
																:
																<Chip sx={{ height: 'auto' }}
																	style={{ textAlign: 'center', backgroundColor: '#d0d0d0', padding: '6px 0px', width: '100%', cursor: 'default' }}
																	label='Assign Shift'
																/>
															}
															{getSignupDelay(row) &&
																<Tooltip title={getSignupDelay(row).message} arrow>
																	<IconButton size="small" sx={{ padding: '2px' }}>
																		<InfoOutlinedIcon sx={{ fontSize: '18px' }} />
																	</IconButton>
																</Tooltip>
															}
														</Box>
													</TableCell>
												</TableRow>
											))
												:
												<TableRow>
													<TableCell colSpan={v3Data?.V3_SHOW_OT_SIGNUP_TIMESTAMP ? 7 : 5} style={{ textAlign: 'center' }}>
														No results found
													</TableCell>
												</TableRow>
											}

										</TableBody>
									</Table>
								</TableContainer>
							</div>
						</Box>
						:
						<Box id="modal-modal-description" sx={{ mt: 2 }}>
							<p style={{ fontSize: '21px', fontWeight: '700' }}>{selectedNameEmp}</p>
							<Box sx={{ minWidth: 120 }}>
								{positionArr?.length === 0 ? (
									<FormControl fullWidth>
										<Select
											displayEmpty
											value={positionArr}
											renderValue={(positionArr) => {
												if (!positionArr || positionArr.length === 0) {
													return <em>No open position for this user</em>;
												}
												return positionArr.join(", ");
											}}
											inputProps={{ "aria-label": "Without label" }}
										>
										</Select>
									</FormControl>
								) : (
									<FormControl fullWidth>
										<InputLabel id="demo-simple-select-label">Position</InputLabel>
										<Select
											labelId="demo-simple-select-label"
											id="demo-simple-select"
											// value={position}
											label="Position"
											onChange={handleChange}
										>
											{positionArr.map((pos) => (
												<MenuItem value={pos}>{pos?.employee_assignment?.position?.SO_Desc || (v3Data?.V3_ALLOW_ALTER_LABEL_TEXTS === 'true' ? 'CPP' : 'Detail')}
													, Shift {pos?.Shift_Code == 2 ? '(Day)' : pos?.Shift_Code == 3 ? '(Night)' : `(Custom ${varFormatTime(`${pos?.Start_Time}-${pos?.End_Time}`, user?.Time_Format)})`}
													{pos?.employee_assignment?.position?.SO_Desc == null && `, Assignment (${pos?.assignment?.SO_Desc})`}
												</MenuItem>
											))}
										</Select>
									</FormControl>
								)}
							</Box>
							<Box className='mt-3' sx={{ display: 'flex', gap: 2 }}>
								<ButtonTheme disabled={!position} color='primary' className='px-5' onClick={() => onSubmitAssign(false)}>
									Assign
								</ButtonTheme>
								{v3Data?.V3_ALLOW_HITLIST_REFRESH_ACTION === 'true' && (
									<ButtonTheme disabled={!position} color='primary' className='px-5' onClick={() => onSubmitAssign(true)}>
										Assign and Refresh hit list
									</ButtonTheme>
								)}
							</Box>
						</Box>
					}
				</Modal.Body>
			</Modal>
			<Modal show={clearModal} onHide={() => setClearModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Clear {isNight ? 'Night' : 'Day'} Hit List</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div style={{ color: '#555555' }}>
						Are you sure you want to clear all employees from the {isNight ? 'Night' : 'Day'} hit list? This will remove them from OT sign-up for this shift.
					</div>
					<Row>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setClearModal(false)}>
								Cancel
							</ButtonTheme>
						</Col>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={clearHitlist}>
								Clear
							</ButtonTheme>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>
		</>
	)
}
export default Hitlist